export const enClientPortalUserSettingsSidebarPages = {
    settings: {
        userSettingsSidebar: {
            sidebar: {
                settings: 'Settings',
                profile: 'My profile',
                notifications: 'Notifications',
            },
        },
    },
}
